import { Divider, Image, Spin } from "antd";
import { fetchDriverByIdQrcode } from "api/driver";
import { statusBadge } from "components/Table";
import { useNotificationContext } from "contexts/NotificationContext";
import { IDriver } from "models/driver";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function DriverQrcode() {
  const qrcode: string = useParams().qrcode!;
  const { showError } = useNotificationContext();
  const [{ loading, data }, setData] = useState<{
    loading: boolean;
    data?: IDriver;
  }>({
    loading: true,
  });

  useEffect(() => {
    fetchData();
  }, [qrcode]); // eslint-disable-line

  const fetchData = async () => {
    setData({ loading: true });
    const { data, error } = await fetchDriverByIdQrcode(qrcode);
    if (data?.data) {
      setData({ loading: false, data: data.data });
    } else showError(error!.message);
  };

  return (
    <div className="w-full flex flex-col max-w-md mx-auto p-4">
      {loading ? (
        <div
          className="w-full bg-white rounded-lg p-6"
          style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
        >
          <div className="w-full flex items-center justify-center py-20">
            <Spin />
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-col gap-y-10">
          <div
            className="w-full bg-white rounded-lg p-6"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <div className="w-full">
              <h4 className="text-lg font-medium">Driver Information</h4>
              <div className="w-full mt-3">
                <Image
                  src={data?.image}
                  preview={false}
                  height={150}
                  className="rounded-md"
                />
              </div>
              <div className="w-full mt-2 flex flex-wrap gap-x-4 justify-between">
                <div className="flex flex-col">
                  <table className="text-sm">
                    <tbody>
                      <tr>
                        <td className="font-bold min-w-36">Full Name</td>
                        <td className="min-w-36 capitalize">
                          {data?.first_name} {data?.middle_name}{" "}
                          {data?.last_name}
                        </td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Phone Number</td>
                        <td className="min-w-36">{data?.phone}</td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Gender</td>
                        <td className="min-w-36 capitalize">{data?.gender}</td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">City</td>
                        <td className="min-w-36 capitalize">
                          {data?.city.name}
                        </td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Status</td>
                        <td className="min-w-36">
                          {statusBadge(data?.is_active ?? false)}
                        </td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Is Verified</td>
                        <td className="min-w-36">
                          {statusBadge(data?.is_verified ?? false)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <Divider />
            </div>
            <div className="w-full mt-6">
              <h4 className="text-lg font-medium">Fleet Information</h4>
              <div className="w-full mt-3">
                <Image
                  src={data?.fleet.image}
                  preview={false}
                  height={150}
                  className="rounded-md"
                />{" "}
              </div>

              <div className="w-full flex flex-wrap">
                <div className="flex flex-col">
                  <table className="text-sm">
                    <tbody>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Fleet Name</td>
                        <td className="min-w-36">
                          {data?.fleet.fleet_model.name}
                        </td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Fleet Brand</td>
                        <td className="min-w-36">{data?.fleet.brand}</td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Fleet Model</td>
                        <td className="min-w-36">{data?.fleet.model}</td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Fleet Color</td>
                        <td className="min-w-36">{data?.fleet.color}</td>
                      </tr>
                      <tr className="mt-4">
                        <td className="font-bold min-w-36">Plate Number</td>
                        <td className="min-w-36">{data?.fleet.plate_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
